<template>
  <div class="box-second ptoTotal">
    <div class="box-main">
        <baidu-map
            :center="center"
            id="xjMap"
            :zoom="zoom"
            @ready="handler"
            style="height:100%;width:100%;"
            :scroll-wheel-zoom="true"
        >
            <bm-marker v-for="(item,index) in points" @click="clickHandler(item)" :key="index" :position="item.position"  :icon="{url: item.url, size: {width: item.width, height: item.height}}">
            </bm-marker>
        </baidu-map>
    </div>
  </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base';
export default {
  data() {
    return {
      groupId: '',
      //地图中心
      center: {
          lng: 117.129186,
          lat: 31.836603
      },
      zoom: 13,
      points:[],
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
  },
  methods: {
    
    //获取数据
    getData() {
      var that = this
      myHttp.findProjectInfo({
          projectId:this.groupId
      }).then(function(resp){
          console.log(resp)
          if(resp.data.code=='200'){
              var data = resp.data.data.result
              if(data && data.gpsPoint){
                  var gps = data.gpsPoint.split(',')
                  that.center.lng = parseFloat(gps[0])
                  that.center.lat = parseFloat(gps[1])
                  that.getDustList()
              }
          }
      })
      
    },
    //获取扬尘设备
    getDustList(){
        var that = this
        //获取扬尘设备
      myHttp.getListByProjectId({
          projectId:this.groupId
      }).then(function(resp) {
        if (resp.data.code == '200') {
            var list = resp.data.data.dustList || []
            that.showMarker(list)
        }
      },function() {})
    },

    //地图展示
    handler({ BMap, map }) {
        this.map = map
        this.getData()
        // var cityName = '安徽省';
        // map.centerAndZoom(cityName, 11);                     // 初始化地图,设置中心点坐标和地图级别。    map.addControl(new BMap.ScaleControl());                    // 添加比例尺控件
        map.enableScrollWheelZoom();
        
    },
    //地图点击方法
    // getClickInfo(e) {
    //     if(!this.curIndex){
    //         var allOverlay = this.map.getOverlays();
    //         for(var i=0;i<allOverlay.length;i++){
    //             if(allOverlay[i].toString()=="[object Overlay]"){
    //                 this.map.removeOverlay(allOverlay[i]);
    //             }
    //         }
    //     }
    //     this.infoWindowClose()
    // },
    //展示地图标记
    showMarker(list){
        var points = [];
        var viewPoints = []
        for (var i = 0; i < list.length; i++) {
            // if(list[i].gpsPoint&&''!=list[i].gpsPoint){
                var obj = list[i]
                var position = [this.center.lng,this.center.lat]
                obj.position = {lng: position[0], lat: position[1]}//扬尘
                var obj1 = JSON.parse(JSON.stringify(list[i]))      //噪音
                obj1.position = {lng: position[0]+0.001, lat: position[1]}
                var obj2 = JSON.parse(JSON.stringify(list[i]))       //气候
                obj2.position = {lng: position[0]+0.002, lat: position[1]}
                if(obj.updateDate && new Date().getTime()-new Date(obj.updateDate).getTime()<36000000){
                    //扬尘
                    obj.url = require('../../../assets/image/icon/dust.png') 
                    obj.width = 48
                    obj.height = 48
                    //噪音
                    obj1.url = require('../../../assets/image/icon/noise.png')
                    obj1.width = 48
                    obj1.height = 48
                    //气候
                    obj2.url = require('../../../assets/image/icon/climate.png')
                    obj2.width = 48
                    obj2.height = 48
                }else{
                    //扬尘
                    obj.url = require('../../../assets/image/icon/dust1.png') 
                    obj.width = 48
                    obj.height = 48
                    //噪音
                    obj1.url = require('../../../assets/image/icon/noise1.png')
                    obj1.width = 48
                    obj1.height = 48
                    //气候
                    obj2.url = require('../../../assets/image/icon/climate1.png')
                    obj2.width = 48
                    obj2.height = 48
                }
                // obj.typeName = list[i].projectType=='1'?'房建':'市政'
                
                // if(list[i].allDay){
                //     var readDay = parseInt(list[i].allDay) - parseInt(list[i].otherDay) 
                //     obj.progress = ((readDay / list[i].allDay) * 100).toFixed(2)
                // }else{
                //     obj.progress = 0
                // }

                // if(obj.projectStatus=='2'){
                //   obj.url = require('../../../assets/image/pro_build.gif')
                //   obj.width = 60,
                //   obj.height = 60
                // }else if(obj.projectStatus=='3'){
                //   obj.url = require('../../../assets/image/pro_build.gif')
                //   obj.width = 60,
                //   obj.height = 60
                // }else if(obj.projectStatus=='4'){
                //   obj.url = require('../../../assets/image/pro_build.gif')
                //   obj.width = 60,
                //   obj.height = 60
                // }
                // points.push(obj)
                // viewPoints.push(new BMap.Point(obj.position.lng,obj.position.lat))
                points.push(obj)
                points.push(obj1)
                points.push(obj2)
            // }
        }
        // console.log(points)
        // this.center = points.length>0?points[0].position:this.center
        this.points = points
        // //设置地图视野zoon和中心点
        // var view = this.map.getViewport(eval(viewPoints));
        
        // if(this.groupId !='1263382107619520513'){
        //   this.center = view.center
        //   var that = this
        //   setTimeout(function(){
        //     that.map.setViewport(viewPoints)
        //   },100)
        // }
        // setTimeout(function(){
        //   var pointBg = document.getElementsByClassName('BMap_Marker')
        //   for(var i=0;i<pointBg.length;i++){
        //     if(pointBg[i].className=='BMap_Marker'){
        //       pointBg[i].parentNode.style.zIndex = 500
        //     }
        //   }
        // },1000)
    },
    //点击方法
    clickHandler(e){
        // this.curIndex = e
        // this.showMapMarker(e)
        this.$router.push({ path: '/dustPro' })
    },
    //关闭
    infoWindowClose(){
        this.curIndex = undefined
    },
    //查看
    // clear(row){
    //     util.session.set('proId', row.id)
    //     util.session.set('backPage', '6')
    //     var that = this
    //     setTimeout(function() {
    //         that.$router.push({ path: '/entProInfo' })
    //     }, 0)
    // },

    //展示地图数据
    showMapMarker(obj){
        var _selt = this
        // 复杂的自定义覆盖物
        function ComplexCustomOverlay(point,obj){
            this._point = point;
            this._option = obj
        }
        ComplexCustomOverlay.prototype = new BMap.Overlay();
        ComplexCustomOverlay.prototype.initialize = function(map){
            this._map = map;
            var option = this._option;
            var div = this._div = document.createElement("div");
            div.style.position = "absolute";
            // div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
            div.style.zIndex = 500;
            div.style.height = "300px";
            div.style.width = "240px";
            div.style.background = "rgba(19, 46, 140, 0.8)";
            div.style.borderRadius = "5px";
            div.style.padding = "10px";
            div.style.cursor = 'pointer'
            var that = this;

            //图片
            var imgDiv = document.createElement("img");
            imgDiv.style.position = "relative";
            imgDiv.style.width = "220px";
            imgDiv.style.height = "150px";
            imgDiv.style.marginBottom = "20px";
            var imgs = option.photoPath.split(',')
            var img = ''
            for(var i=0;i<imgs.length;i++){
                if(imgs[i]!=''){
                    img = base.httpCtx+imgs[i]
                }
            }
            if(img==''){
                // imgDiv.src = require('../../assets/image/zanwutupian.png')
            }else{
                imgDiv.src = img
            }
            div.appendChild(imgDiv);

            //项目名称
            var nameText = document.createElement("p");
            nameText.style.position = "relative";
            nameText.style.width = "100%";
            nameText.style.height = "30px";
            nameText.style.fontSize = "14px";
            nameText.style.color = "rgba(255, 255, 255, 1)";
            nameText.style.whiteSpace = "nowrap";
            nameText.style.textOverflow = "ellipsis";
            nameText.style.overflow = "hidden";
            nameText.innerHTML = option.name||'';
            nameText.title = option.name||'';
            div.appendChild(nameText);

            //项目位置
            var addrText = document.createElement("p");
            addrText.style.position = "relative";
            addrText.style.width = "100%";
            addrText.style.height = "30px";
            addrText.style.fontSize = "12px";
            addrText.style.color = "rgba(255, 255, 255, 1)";
            addrText.style.whiteSpace = "nowrap";
            addrText.style.textOverflow = "ellipsis";
            addrText.style.overflow = "hidden";
            addrText.title = option.address||'';
            addrText.innerHTML = '项目位置：'+option.address;
            div.appendChild(addrText);

            //投资进度
            // var progressText = document.createElement("p");
            // progressText.style.position = "relative";
            // progressText.style.width = "100%";
            // progressText.style.height = "30px";
            // progressText.style.fontSize = "12px";
            // progressText.style.color = "rgba(255, 255, 255, 1)";
            // progressText.innerHTML = '投资进度：'+(option.cumulativeComplete||0)+'%'+', 金额：'+(option.price||0)+'万';
            // div.appendChild(progressText);

            //工期
            var dateText = document.createElement("p");
            dateText.style.position = "relative";
            dateText.style.width = "100%";
            dateText.style.height = "30px";
            dateText.style.fontSize = "12px";
            dateText.style.color = "rgba(255, 255, 255, 1)";
            dateText.innerHTML = '工期：'+option.allDay+'天, 剩余：'+option.otherDay+'天（'+option.progress+'%）';
            div.appendChild(dateText);

            div.onclick = function(){
                // util.session.set('proId', option.id)
                // util.session.set('backPage', '4')
                // //var that = this
                // setTimeout(function() {
                //     _selt.$router.push({ path: '/attendTeamCom' })
                // }, 0)
            }

            map.getPanes().labelPane.appendChild(div);
            
            return div;
        }
        ComplexCustomOverlay.prototype.draw = function(){
            var map = this._map;
            var pixel = map.pointToOverlayPixel(this._point);
            this._div.style.left = (pixel.x + 20) + 'px' ;
            this._div.style.top  = pixel.y  + 'px' ;
        }
        var allOverlay = this.map.getOverlays();
        for(var i=0;i<allOverlay.length;i++){
            if(allOverlay[i].toString()=="[object Overlay]"){
                this.map.removeOverlay(allOverlay[i]);
            }
        }
        var gpsLi = obj.gpsPoint.split(",");
        var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi[0], gpsLi[1]),obj);
        this.map.addOverlay(myCompOverlay);
        
    },
    /**
     * 获取企业组织架构
     */
    // getOfficeList(){
    //   var that = this
    //   myHttp.getOfficeList({
    //     entId:this.groupId
    //   }).then(function(resp){
    //     //console.log(resp)
    //     if(resp.data.code=='200'){
    //       var list = resp.data.data.officeList||[]
    //       that.offices = list
    //     }
    //   })
    // },
    /**
     * 修改
     */
    // updataFun(row){
    //   var that = this
    //   myHttp.editEntOfficeProjectInformation({
    //     entId:this.groupId,
    //     projectId:row.id
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       var data = resp.data.data
    //       that.addForm.projectName = data.projectName
    //       that.addForm.projectId = data.projectId
    //       that.addForm.officeId = data.officeId||''
    //       that.modVisible = true
    //       that.getOfficeList()
    //     }
    //   })
    // },

    /**
     * 修改
     */
    // sumbitModRow(){
    //   var that = this
    //   myHttp.editEntOfficeProject({
    //     officeId:that.addForm.officeId,
    //     entId:this.groupId,
    //     projectId:this.addForm.projectId
    //   }).then(function(resp){
    //     if(resp.data.code=='200'){
    //       that.$message.success('添加成功')
    //       that.modVisible = false
    //     }else{
    //       that.$message.error(resp.data.msg)
    //     }
    //   })
    // },

    /**
     * 
     */
    // _formatRate(value){
    //   return () => {
    //     return value + '%'
    //   }
    // },
  }
}
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.nowrap {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.box-second {
  width: 100%;
  position: relative;
  height: 100%;
  background: #fff;
}
.box-head {
  width: 100%;
  height: 5vh;
  position: relative;
  display: flex;
  padding: 0 1vw;
  background: #f5f5f5;
  align-content: center;
  align-items: center;
}
.head-name {
  display: flex;
  align-items: center;
  color: #6b6b6b;
  font-size: 18px;
}
.head-num {
  flex: 1;
  padding: 0 20px;
  display: flex;
  align-items: center;
}
.head-search1 {
  width: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.box .el-submenu {
  margin-right: 20px;
}
.box .el-submenu p{
  font-size: 0.95vw;
}

.box-main{
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  background: #EEEFF8;
}
.box-main-left{
  width: 60%;
  height: 100%;
  position: relative;
  padding: 1vh;
}
.box-table {
  width: 40%;
  height: 100%;
  position: relative;
  overflow: auto;
}
.box-table-item {
  width: 100%;
  height: 12vh;
  margin-top: 1.4vh;
  margin-bottom: 1.4vh;
  /* background: #f5f5f5; */
  justify-content: space-between;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* color: #aecfdc; */
  box-sizing: border-box;
  font-size: 18px;
  padding: 20px;
}
.ptoTotal p {
  margin: 0;
}
.map-tip{
  position: absolute;
  top: 2vh;
  right: 2vh;
  width: 6vh;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  justify-items: center;
  background: #fff;
  padding: 1vh 0.5vh;
  box-shadow: 0px 0px 5px 2px #ddd;
  border-radius: 5px;
}
</style>
<style>
  .head-num .el-menu--horizontal {
    background: transparent;
    border-bottom: 0;
  }
  .head-num .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 40px;
    line-height: 40px;
    border-bottom: 0;
    color: #6b6b6b;
    background: transparent;
    font-size: 18px;
  }
  .head-num .el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
    display: none;
  }
  .el-menu--horizontal .total-item {
    /* background-color: rgb(0, 20, 152); */
    font-size: 16px;
    color: #000 !important;
  }
  .box-table-item .progress1 .el-progress-bar__outer {
    background-color: #DADEFD;
  }
  .progress2 .el-progress-bar__outer {
    background-color: #DADEFD;
  }
  .fen-val .el-input__inner {
    background: transparent;
    border: 0;
    font-size: 16px;
    text-align: right;
    /* color: #fff; */
  }
  .fen-sel,
  .fen-sel .el-select-dropdown__item.hover,
  .fen-sel .el-select-dropdown__item:hover {
    /* background: #001498; */
    background: #fff;
    border: 0;
  }
  .fen-sel .el-select-dropdown__empty,
  .fen-sel .el-select-dropdown__item {
    color: #000;
  }
  .fen-val.el-select .el-input {
    width: 240px;
  }
  .ptoTotal .el-pagination span {
    color: #000;
  }
  .ptoTotal .el-pagination .el-input__inner {
    background: transparent;
    color: #000;
  }
  .ptoTotal .el-menu--horizontal {
    box-shadow: none;
  }

  .ptoTotal .el-progress-bar__innerText{
    font-size: inherit;
  }
  .ptoTotal .el-progress-bar__innerText{
    color: #fff;
    text-shadow: 0 0 1px currentColor,-1px -1px 1px #000,0 -1px 1px #000,1px -1px 1px #000,1px 0 1px #000,1px 1px 1px #000,0 1px 1px #000,-1px 1px 1px #000,-1px 0 1px #000;
  }
</style>